import React from 'react'
import propTypes from 'prop-types'

const SearchBox = props => (
  <div className='ba-box-search-input'>
    <input type='search' className='ba-input ba-sm'
      placeholder={props.label}
      onChange={e => props.handleChange(e.target.value)}
    />
    <button className='ba-button'>
      <builderall-icon code='search' />
    </button>
  </div>
)

SearchBox.propTypes = {
  /** label of search  */
  label: propTypes.string,
  /** Handle of the change  */
  handleChange: propTypes.func
}

SearchBox.defaultProps = {
  label: 'Search'
}

export default SearchBox



// WEBPACK FOOTER //
// ./src/components/SearchBox/index.js